const STANDARD_COLORS = {
  white: "#ffffff",
  black: "#000000",
};

const WHITE = {
  backgroundWhite: "#fafcf3",
};
const BLACK = {
  lightBlack: "#212026",
};

const BLUE = {
  backgroundBlue: "#F8FBFD",
  lightBlue: "#E6F4FC",
  lightBlue2: "#CDECFC",
  lightBlue3: "#ABE1FA",
  lightBlue4: "#e6f6fd",
  lightBlueGreen: "#94BDCF",
  blueGreen: "#6AA1B8",
  blueGreen1: "#6ba1b6",
  darkBlueGreen: "#0F475D",
  darkBlueGreen2: "#35515C",
  darkBlue: "#000543",
};

const GREEN = {
  green: "#B1D34A",
  darkGreen: "#596A25",
  lightGreen: "#3E703D",
  lightGreen2: "#64A446",
};

const GREY = {
  lightGrey: "#f2f2f2",
  lightGrey3: "#E2EAEE",
  lightGrey2: "#abbec5",
  grey: "#abbec5",
  darkGrey: "#bfbfbf",
  darkGrey2: "#bfbfbf",
  borderGrey: "#707070",
};

const RED = {
  lightRed: "#FF9985",
  lightRed2: "#FA694F",
  pink: "#F9CAE2",
};

const COLORS = {
  STANDARD_COLORS: { ...STANDARD_COLORS },
  WHITE: { ...WHITE },
  BLACK: { ...BLACK },
  BLUE: { ...BLUE },
  GREEN: { ...GREEN },
  GREY: { ...GREY },
  RED: { ...RED },
};

const GRADIENTS = {};

const palette = {
  COLORS: { ...COLORS },
  GRADIENTS: { ...GRADIENTS },
  typography: { ...{ fontFamily: ["noto-sans"] } },
};
export default palette;
